/**
 * AUTO-GENERATED by scripts/process-module-manifests.ts -- DO NOT EDIT.
 * Re-run `pnpm generate:modules` to regenerate this file.
 */
import type { CustomModuleProps } from "@nucleus/shared-types";
import { lazy, type ComponentType, type LazyExoticComponent } from "react";

type LazyCustomModule = LazyExoticComponent<ComponentType<CustomModuleProps>>;

export const GENERATED_MODULE_REGISTRY: Record<string, LazyCustomModule> = {
	"ad-builder-project-board": lazy(
		() => import("@nucleus/mod-ad-builder-project-board/frontend")
	),
	"daa-budget-tracker": lazy(
		() => import("@nucleus/mod-daa-budget-tracker/frontend")
	),
	"daa-pmi-master": lazy(
		() => import("@nucleus/mod-daa-pmi-master/frontend")
	),
	"datapipes": lazy(
		() => import("@nucleus/mod-datapipes/frontend")
	),
	"fusion": lazy(
		() => import("@nucleus/mod-fusion/frontend")
	),
	"media-explorer": lazy(
		() => import("@nucleus/mod-media-explorer/frontend")
	),
};
